import * as React from "react";
import { SVGProps } from "react";
const SvgWind = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="m22.857 17.996-1.087-.628a5.989 5.989 0 0 0-1.472-2.55v-1.254C20.298 9.218 19.4 1 16 1c-3.4 0-4.298 8.218-4.298 12.564v1.254a5.99 5.99 0 0 0-1.472 2.55l-1.087.628C5.38 20.169-1.288 25.056.412 28c1.7 2.944 9.266-.387 13.03-2.56l1.089-.629a5.814 5.814 0 0 0 2.939 0l1.09.629c3.763 2.173 11.33 5.504 13.03 2.56 1.7-2.944-4.97-7.831-8.733-10.004ZM15.999 3c.663.09 2.28 3.864 2.297 10.457a5.994 5.994 0 0 0-4.592 0C13.72 6.861 15.338 3.087 15.999 3ZM2.144 27c-.254-.619 2.208-3.907 7.912-7.22a5.986 5.986 0 0 0 2.297 3.977C6.63 27.043 2.551 27.53 2.144 27.001ZM13 19a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm16.857 8c-.41.53-4.489.04-10.21-3.243a5.986 5.986 0 0 0 2.297-3.977c5.707 3.314 8.168 6.602 7.913 7.22Z"
    />
  </svg>
);
export default SvgWind;
